// extracted by mini-css-extract-plugin
module.exports = {"description":"searchList_description_2xYH3"};